<section class="agu-band" [attr.data-accent]="Accent">
    @if (Eyebrow) {
        <p class="agu-band__eyebrow">{{ Eyebrow }}</p>
    }
    <h1 class="agu-band__title">{{ Title }}</h1>
    @if (Sub) {
        <p class="agu-band__sub">{{ Sub }}</p>
    }
</section>
